module.exports = __webpack_public_path__ + "img/im.7fd93adb.svg";